import { render, staticRenderFns } from "./Pengeluaran.vue?vue&type=template&id=231d52ae&scoped=true&"
import script from "./Pengeluaran.vue?vue&type=script&lang=js&"
export * from "./Pengeluaran.vue?vue&type=script&lang=js&"
import style0 from "./Pengeluaran.vue?vue&type=style&index=0&id=231d52ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d52ae",
  null
  
)

export default component.exports